import classNames from 'classnames';
import useStyles from './styles';

function StartForFreeFallback() {
  const styles = useStyles({ titleColor: '' });

  return (
    <section>
      <i className={classNames(styles.sectionSkeleton, 'skeleton')} />
    </section>
  );
}

export default StartForFreeFallback;
